export const PLAN_STYLES = {
  plan: {
    container: '!bg-green-50 !border !border-green-300',
    title: '!text-green-800',
    button: '!bg-green-500 !text-white',
  },
  plan_update: {
    container: '!bg-blue-50 !border !border-blue-300',
    title: '!text-blue-800',
    button: '!bg-blue-500 !text-white',
  },
  decline: {
    container: '!bg-red-50 !border !border-red-300',
    title: '!text-red-800',
    button: '!bg-red-500 !text-white',
  },
} as const;
